import {
  AppointmentCancellationReason,
  AppointmentDeliveryMethod,
  AppointmentStatus,
} from '~/graphql/generated/graphql';

type CanceledByType = '薬局' | '患者' | '不明';

export const translateReason = (
  reason: AppointmentCancellationReason,
  status?: AppointmentStatus,
  hasWaitingForChargeHistory?: boolean,
): { canceledBy: CanceledByType; detail: string } => {
  switch (reason) {
    case 'pat':
      if (status === 'noshow') {
        return hasWaitingForChargeHistory
          ? { canceledBy: '薬局', detail: '患者都合でのキャンセル' }
          : { canceledBy: '薬局', detail: '患者が来店せず、連絡もとれない' };
      }
      return { canceledBy: '薬局', detail: '有効期限内に原本が届かなかった' };
    case 'pat_cpp':
      return { canceledBy: '患者', detail: '患者からキャンセルされた' };
    case 'prov':
      return { canceledBy: '薬局', detail: 'お薬の在庫がなかった' };
    case 'other':
      return { canceledBy: '薬局', detail: 'その他' };
    default:
      return { canceledBy: '不明', detail: '不明' };
  }
};

export const isB2Cloud = (deliveryMethod: AppointmentDeliveryMethod): boolean => {
  return deliveryMethod.startsWith('b2cloud_');
};
